import { Button, ButtonProps } from '@braskai/ui-kit';

import { styled } from '@mui/material';

type ActionButtonProps = {
  isTransparent?: boolean;
} & ButtonProps;

export const ActionButton = styled(({ isTransparent, ...props }: ActionButtonProps) => {
  return <Button size="sm" variant={isTransparent ? 'outlined' : 'primary'} {...props} />;
})(() => ({
  marginTop: 'auto',
  width: '100%',
  whiteSpace: 'nowrap',
}));
